import { AspectRatio, Box } from '@chakra-ui/react';
import { MotionBox } from '@time-line/components/common';

const circleActiveBorderColors = {
  inactive: 'blackAlpha.250',
  active: 'blackAlpha.500',
};

const circlePositions = [
  {
    top: '10%',
    left: '-50%',
    color: circleActiveBorderColors.active,
    isLarge: true,
    x: [-20, 20],
    y: [20, -20],
  },
  {
    top: '-20%',
    right: '5%',
    x: [0, 0],
    y: [20, -10],
  },
  {
    top: '20%',
    x: [-5, 5],
    y: [-20, 20],
  },
  {
    top: 0,
    right: 0,
    color: circleActiveBorderColors.active,
    isLarge: true,
    x: [-20, 20],
    y: [-10, 10],
  },
  {
    top: '-30%',
    x: [10, -20],
    y: [0, -20],
  },
  {
    top: '25%',
    right: '50%',
    x: [10, -10],
    y: [20, 0],
  },
  {
    top: '-15%',
    x: [-10, 10],
    y: [-10, 10],
  },
  {
    top: '20%',
    x: [0, -10],
    y: [0, 20],
  },
  {
    top: '-35%',
    color: circleActiveBorderColors.active,
    isLarge: true,
    x: [-10, 20],
    y: [0, -20],
  },
];

const variants = {
  initial: (i: number) => ({
    x: circlePositions[i].x,
    y: circlePositions[i].y,
    rotate: 0,
    transition: {
      delay: Math.random() * 5,
      duration: Math.random() * 5 + 2,
      repeat: Infinity,
      repeatType: 'reverse' as const,
    },
  }),
};

interface CellsProps {
  isScrolled: boolean;
}

export function Cells({ isScrolled }: CellsProps) {
  return (
    <>
      {Array.from({ length: 9 }).map((_, i) => {
        const isActive = isScrolled || circlePositions[i].isLarge;

        return (
          <AspectRatio
            as={MotionBox}
            key={i}
            ratio={1}
            color={circleActiveBorderColors.inactive}
            custom={i}
            animate={['initial']}
            variants={variants}
            top={circlePositions[i].top}
            right={circlePositions[i].right}
            left={circlePositions[i].left}
          >
            <Box
              display="inline-block"
              transitionProperty="common"
              transitionDuration="slow"
              transitionDelay={`${i * 0.1}s`}
              position="relative"
              transform={isActive ? 'scale(1)' : 'scale(0.85)'}
              borderWidth={1}
              borderRadius="full"
              borderColor={
                isActive ? circleActiveBorderColors.active : 'currentColor'
              }
            />
          </AspectRatio>
        );
      })}
    </>
  );
}
